import {
    Segmented,
    Input,
    Upload,
    Button,
    Space,
    Modal,
    message,
    Grid,
} from "antd";
import React, { useState, useEffect, useMemo } from "react";
import { useBotEndpoint, useUploadMedia } from "../../_actions/bot";
import {
    ClockCircleOutlined,
    PlusOutlined,
    LoadingOutlined,
    PlayCircleOutlined,
} from "@ant-design/icons";
import log from "cslog";
import { Image } from "antd";
import { CalendarOutlined, SaveOutlined } from "@ant-design/icons";
import { SchedulePicker } from "../NewAddPanel";
import SocialAccountDropdown from "../../social_media/SocialAccountDropdown";
import SocialAccountSelection from "../../social_media/SocialAccountSelection";

const INSTAGRAM_MAPPING = {
    post: "INSTAGRAM_POST",
    reel: "INSTAGRAM_REEL",
    story: "INSTAGRAM_STORY",
};

function getPostType(platform, media_type) {
    if (platform === "Instagram") {
        return INSTAGRAM_MAPPING[media_type];
    } else if (platform === "Linkedin") {
        return "LINKEDIN_POST";
    }
}

function ExternalPostPanel({ me = {}, action, onClose }) {
    const { useBreakpoint } = Grid;
    const screens = useBreakpoint();
    const isMobile = !screens.sm;
    const [post_type, setPostType] = useState("post");
    const [caption, setCaption] = useState("");
    const [media, setMedia] = useState([]);
    const [posting_account, setPostingAccount] = useState([]);
    const [posting_account_full, setPostingAccountFull] = useState([]);

    const allInstagram = useMemo(() => {
        return (
            posting_account_full.length > 0 &&
            posting_account_full.every((acc) => acc.platform === "Instagram")
        );
    }, [posting_account_full]);

    const hasInstagram = useMemo(() => {
        return posting_account_full.some((acc) => acc.platform === "Instagram");
    }, [posting_account_full]);

    useEffect(() => {
        if (!allInstagram) {
            setPostType("post");
        }
    }, [allInstagram]);

    const mutationBot = useBotEndpoint(
        "/social_post/schedule_external_post",
        () => {},
        () => {}
    );

    const schedulePost = (posting_dt) => {
        const payload = {
            organization_id: me.selected_org?.id,
            posting_dt: posting_dt,
            caption: caption,
            media_assets: media.map((item) => ({
                id: item.id,
                public_url: item.public_url,
                content_type: item.content_type,
                ...(item.content_type.startsWith("video")
                    ? { preview_url: item.preview_url }
                    : {}),
            })),
            platforms: posting_account_full.map((acc) => ({
                // post_type: PLATFORM_MAPPING[post_type],
                post_type: getPostType(acc.platform, post_type),
                scheduled_time: posting_dt,
                posting_account: acc.id,
            })),
        };
        log.d(payload, "payload for external post");
        mutationBot.mutate(payload, {
            onSuccess: (result) => {
                if (result?.success) {
                    log.d(result, "result for external post");
                    if (onClose) onClose();
                }
            },
        });
    };

    return (
        <div style={{ maxWidth: "500px" }}>
            <SocialAccountSelection
                org_id={me.selected_org?.id}
                value={posting_account}
                onChange={(value) => setPostingAccount(value)}
                onChangeFull={(value) => setPostingAccountFull(value)}
                auto_configure={true}
            />
            <br />
            <br />

            {allInstagram && (
                <Segmented
                    options={[
                        { label: "Post", value: "post" },
                        { label: "Reel", value: "reel" },
                        { label: "Story", value: "story" },
                    ]}
                    onChange={(value) => setPostType(value)}
                    value={post_type}
                    style={{ marginBottom: 16 }}
                />
            )}
            <MediaUploadBox
                value={media}
                onChange={(new_value) => setMedia(new_value)}
                post_type={post_type}
            />
            {post_type !== "story" && (
                <CaptionBox
                    value={caption}
                    onChange={(e) => setCaption(e.target.value)}
                />
            )}

            {/* <SocialAccountDropdown
            org_id={me.selected_org?.id}
            value={posting_account}
            onChange={(value) => setPostingAccount(value)}
            auto_configure={true}
        /> */}

            {/* <pre>{JSON.stringify(action, null, 2)}</pre> */}

            <Space style={{ paddingTop: "16px" }}>
                <Button size={isMobile ? "large" : "middle"} block={isMobile}>
                    Save Draft
                </Button>
                <SchedulePicker
                    initial_value={action.date}
                    onSchedule={(date) => {
                        schedulePost(date);
                    }}
                    trigger={
                        <Button
                            type="primary"
                            icon={<ClockCircleOutlined />}
                            size={isMobile ? "large" : "middle"}
                            block={isMobile}
                            disabled={
                                !posting_account ||
                                posting_account.length === 0 ||
                                (hasInstagram
                                    ? media.length === 0
                                    : caption.trim().length < 3 &&
                                      media.length === 0)
                            }
                            loading={mutationBot.isLoading}
                        >
                            Schedule
                        </Button>
                    }
                />
            </Space>
        </div>
    );
}

export default ExternalPostPanel;

export function CaptionBox({ value, onChange }) {
    const { useBreakpoint } = Grid;
    const screens = useBreakpoint();
    const isMobile = !screens.sm;

    return (
        <Input.TextArea
            value={value}
            onChange={onChange}
            placeholder="Write something.."
            rows={isMobile ? 8 : 4}
            style={{ marginBottom: "16px" }}
        />
    );
}

function MediaUploadBox({ value = [], onChange = () => {}, post_type }) {
    const mutationUploadMedia = useUploadMedia(
        () => {},
        () => {}
    );
    const [previewOpen, setPreviewOpen] = useState(false);
    const [previewImage, setPreviewImage] = useState("");
    const [previewVideoOpen, setPreviewVideoOpen] = useState(false);
    const [previewVideoUrl, setPreviewVideoUrl] = useState("");

    const hasVideo = value?.some((item) =>
        item?.content_type?.startsWith("video")
    );

    const handleUploadMedia = (file) => {
        const formData = new FormData();
        formData.append("file", file?.originFileObj || file);
        mutationUploadMedia.mutate(formData, {
            onSuccess: (result) => {
                if (result?.success) {
                    onChange([...value, result?.data]);
                }
            },
        });
    };

    const handlePreview = async (file) => {
        if (file.is_video) {
            setPreviewVideoUrl(file.public_url || file.url);
            setPreviewVideoOpen(true);
            return;
        }

        if (!file.url && !file.preview) {
            file.preview = await getBase64(file.originFileObj);
        }

        setPreviewImage(file.url || file.preview);
        setPreviewOpen(true);
    };

    let acceptTypes = value?.length > 0 ? "image/*" : "image/*,video/*";
    if (post_type === "reel") acceptTypes = "video/*";

    return (
        <div style={{ paddingBottom: "16px" }}>
            <Upload
                accept={acceptTypes}
                fileList={value?.map((item) => ({
                    uid: item?.id,
                    name: item?.id,
                    status: "done",
                    url: item?.preview_url || item?.public_url,
                    public_url: item?.public_url,
                    is_video: item?.content_type?.startsWith("video"),
                }))}
                customRequest={({ file, onSuccess }) => {
                    handleUploadMedia(file);
                    onSuccess("ok");
                }}
                beforeUpload={(file) => {
                    const isVideo = file.type.startsWith("video");
                    if (post_type === "reel" && !isVideo) {
                        message.error("Only videos are allowed for Reels");
                        return Upload.LIST_IGNORE;
                    }
                    if (isVideo && value?.length > 0) {
                        message.error("Video can only be uploaded alone");
                        return Upload.LIST_IGNORE;
                    }
                    return true;
                }}
                onRemove={(file) => {
                    onChange(value.filter((item) => item.id !== file.uid));
                }}
                listType="picture-card"
                onPreview={handlePreview}
                itemRender={(originNode, file) => {
                    if (file.is_video) {
                        return (
                            <div
                                style={{
                                    position: "relative",
                                    width: "100%",
                                    height: "100%",
                                }}
                            >
                                {originNode}
                                <PlayCircleOutlined
                                    style={{
                                        position: "absolute",
                                        top: "50%",
                                        left: "50%",
                                        transform: "translate(-50%, -50%)",
                                        fontSize: "28px",
                                        color: "rgba(255, 255, 255, 0.85)",
                                        pointerEvents: "none",
                                    }}
                                />
                            </div>
                        );
                    }
                    return originNode;
                }}
            >
                {!hasVideo && (
                    <div>
                        {mutationUploadMedia.isLoading ? (
                            <LoadingOutlined />
                        ) : (
                            <PlusOutlined />
                        )}
                        <div style={{ marginTop: 8 }}>
                            {mutationUploadMedia.isLoading
                                ? "Uploading"
                                : "Upload"}
                        </div>
                    </div>
                )}
            </Upload>

            {previewImage && (
                <Image
                    wrapperStyle={{ display: "none" }}
                    preview={{
                        visible: previewOpen,
                        onVisibleChange: (visible) => setPreviewOpen(visible),
                        afterOpenChange: (visible) =>
                            !visible && setPreviewImage(""),
                    }}
                    src={previewImage}
                />
            )}

            <Modal
                open={previewVideoOpen}
                visible={previewVideoOpen}
                footer={null}
                onCancel={() => {
                    setPreviewVideoOpen(false);
                    setPreviewVideoUrl("");
                }}
                centered
                styles={{ body: { padding: 0, backgroundColor: "#000" } }}
                destroyOnHidden
                width={800}
            >
                {previewVideoUrl && (
                    <video
                        src={previewVideoUrl}
                        controls
                        autoPlay
                        style={{
                            width: "100%",
                            maxHeight: "80vh",
                            display: "block",
                        }}
                    />
                )}
            </Modal>
        </div>
    );
}

const getBase64 = (file) =>
    new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
    });
